import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DocumentValidationService {
  constructor(private http: HttpClientService) {}

  public last_document_validation(application_id, category, documents_id?): Observable<any> {
    const options = {
      params: {
        application_id: application_id,
        category: category,
        "documents_id[]": documents_id,
      },
    };
    return this.http
      .get("/api/applications/" + application_id + "/document_validations/last_document_validation", options)
      .pipe(tap((_) => console.log("DocumentValidationService.show: Ok.")));
  }

  public update(document_validation): Observable<any> {
    let options = {
      document_validation,
    };
    return this.http
      .put("/api/document_validations/" + document_validation.id, options)
      .pipe(tap((_) => console.log("DocumentValidationService.update: Ok.")));
  }

  public index(application_id: number): Observable<any> {
    return this.http
      .get("/api/applications/" + application_id + "/document_validations")
      .pipe(tap((_) => console.log("DocumentValidationService.index: Ok.")));
  }

  public create(document_validation: any): Observable<any> {
    return this.http
      .post("/api/document_validations", document_validation)
      .pipe(tap((_) => console.log("DocumentValidationService.create: Ok.")));
  }

  public find(application_id, category): Observable<any> {
    const options = {
      params: {
        application_id,
        category,
      },
    };
    return this.http
      .get("/api/applications/" + application_id + "/document_validations/find", options)
      .pipe(tap((_) => console.log("DocumentValidationService.find: Ok.")));
  }

  public getAll(application_id): Observable<any> {
    const options = {
      params: {
        application_id,
      },
    };
    return this.http
      .get("/api/document_validations/all", options)
      .pipe(tap((_) => console.log("DocumentValidationService.getAll: Ok.")));
  }

  public reset(app_id, category): Observable<any> {
    const options = {
      application_id: app_id,
      category: category,
    };
    return this.http
      .put("/api/applications/" + app_id + "/document_validations/reset", options)
      .pipe(tap((_) => console.log("DocumentValidationService.reset: Ok")));
  }
}
